<template>
  <Transition v-if="GetFlagLoaderCards" name="fade">
    <div class="card-single base-card">
      <div class="card-group">
        <h1>
          {{ title }}
          <br />
          <span>(últimos 6 meses)</span>
        </h1>

        <div class="value-primary-grap">
          {{ CountQuestion }}
        </div>
      </div>

      <div class="container-data-request">
        <div
          class="container-months"
          v-for="(data, index) in Question"
          :key="index"
        >
          <div class="item">
            <div class="container-meter">
              <div class="value-grap">({{ data.value }})</div>
              <meter
                min="0"
                :max="maxValue"
                optimum="100"
                :value="data.value"
              ></meter>
            </div>
            <div class="month">
              {{ data.month }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </Transition>
  <div v-else class="card-single base-card">
    <div class="title_skeleton">
      <VueSkeletonLoader
        type="rect"
        :width="170"
        :height="15"
        animation="fade"
      />
    </div>
    <div class="container_fix">
      <div class="">
        <VueSkeletonLoader
          type="rect"
          :width="70"
          :height="15"
          animation="fade"
        />
      </div>

      <div class="test">
        <VueSkeletonLoader
          type="circle"
          :width="50"
          :height="50"
          animation="fade"
        />
      </div>
    </div>
    <div class="body_skeleton_graphic">
      <VueSkeletonLoader
        type="rect"
        :width="10"
        :height="140"
        animation="fade"
      />
      <VueSkeletonLoader
        type="rect"
        :width="10"
        :height="140"
        animation="fade"
      />
      <VueSkeletonLoader
        type="rect"
        :width="10"
        :height="140"
        animation="fade"
      />
      <VueSkeletonLoader
        type="rect"
        :width="10"
        :height="140"
        animation="fade"
      />
      <VueSkeletonLoader
        type="rect"
        :width="10"
        :height="140"
        animation="fade"
      />
      <VueSkeletonLoader
        type="rect"
        :width="10"
        :height="140"
        animation="fade"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VueSkeletonLoader from "skeleton-loader-vue";
export default {
  props: ["title", "Question", "countQuestion"],
  components: {
    VueSkeletonLoader,
  },

  data: function () {
    return {
      maxValue: "",
      total: 0,
      flagLoadDataCards: false,
    };
  },

  computed: {
    ...mapGetters("Home", {
      CountQuestion: "CountQuestion",
      GetFlagLoaderCards: "GetFlagLoaderCards",
    }),
  },

  created() {
    // if (this.GetFlagLoaderCards) {
    //   const maxValueFromArray = Math.max(
    //     ...this.Question.map((o) => o.valueNumber),
    //     0
    //   );
    //   console.log("max: ", maxValueFromArray)
    //   this.Question.forEach((element) => {
    //     this.total += element.valueNumber;
    //   });
    //   this.maxValue = maxValueFromArray;
    // }
    // const maxValueFromArray = Math.max(
    //   ...this.Question.map((o) => o.valueNumber),
    //   0
    // );
    // this.Question.forEach((element) => {
    //   this.total += element.valueNumber;
    // });
    // this.maxValue = maxValueFromArray;
    // console.log("total card 2:", this.maxValue);
  },

  watch: {
    GetFlagLoaderCards(old) {
      if (old) {
        this.flagLoadDataCards = old;

        const maxValueFromArray = Math.max(
          ...this.Question.map((o) => o.valueNumber),
          0
        );

        this.Question.forEach((element) => {
          this.total += element.valueNumber;
        });

        this.maxValue = maxValueFromArray;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./cardFeatures.scss";
@import "../sharedComponents.scss";
</style>
